import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-wartungsbericht-pumpstationen',
  templateUrl: './form-wartungsbericht-pumpstationen.component.html',
  styleUrls: ['./form-wartungsbericht-pumpstationen.component.scss'],
})
export class FormWartungsberichtPumpstationenComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() anlagenreihe: string;

  ngOnInit() {}
}
